module.exports = __webpack_public_path__ + "media/images/pc/articles/popular_contents_costumes-6b9727b4e0b1934bf919c650cbdca3cf.webp";